import UserPhysicalAttributes from './UserPhysicalAttributes';

export default UserPhysicalAttributes;
